import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Reservation } from './reservation.model';
import { ReservationPopupService } from './reservation-popup.service';
import { ReservationService } from './reservation.service';
import { School, SchoolService } from '../school';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { Lesson, LessonService } from '../lesson';
import { ReservationCancellationReason, ReservationCancellationReasonService } from '../reservation-cancellation-reason';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-reservation-dialog',
    templateUrl: './reservation-dialog.component.html'
})
export class ReservationDialogComponent extends AbstractDialogComponent implements OnInit {

    public static readonly MAX_DAYS_TO_SHOW = 7;
    reservation: Reservation;
    authorities: any[];
    isSaving: boolean;
    isUpdating: boolean;
    bypassRules: boolean;
    lessons: Lesson[];
    reservationcancellationreasons: ReservationCancellationReason[];
    title: String;

    search = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.reservation.student['user']);

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private reservationService: ReservationService,
        schoolService: SchoolService,
        private studentService: StudentService,
        private lessonService: LessonService,
        private reservationCancellationReasonService: ReservationCancellationReasonService,
        private eventManager: EventManager,
        private studentTypeaheadService: StudentTypeaheadService,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();
        if (this.reservation.lesson) {
            this.lessons = [];
            this.lessons.push(this.reservation.lesson);
        } else {
            this.lessonService.search({
                query: this.getLessonsQuery(),
                sort: this.lessonsSort()
            })
            .subscribe(
            (res: HttpResponse<Lesson[]>) => {
                let lessons: Lesson[] = res.body;
                let reservationLesson: Lesson = this.reservation ? this.reservation.lesson : null;
                if (lessons.length === 0 && reservationLesson) {
                    // We make sure that at least the lesson of the reservation is available for create/edit the reservation.
                    lessons.push(reservationLesson);
                }
                this.lessons =  lessons;
            },
            (res: HttpErrorResponse) => this.onError(res));
        }

        this.reservationCancellationReasonService.query().subscribe(
            (res: HttpResponse<ReservationCancellationReason[]>) => { this.reservationcancellationreasons = res.body; },
            (res: HttpErrorResponse) => this.onError(res));
        this.isUpdating = this.reservation.id !== undefined;

        if (this.reservation && !this.reservation.lesson) {
            this.title = 'jYoguiApp.reservation.home.createOrEditLabelForPeriod';
        } else {
            this.title = 'jYoguiApp.reservation.home.createOrEditLabel';
        }

    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.reservation.student instanceof Object) {
            this.isSaving = true;
            if (this.reservation.id !== undefined) {
                this.reservationService.update(this.reservation, this.bypassRules)
                    .subscribe((res: Reservation) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
            } else {
                this.reservationService.create(this.reservation, this.bypassRules)
                    .subscribe((res: Reservation) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
            }
        } else {
            let studentInput = form !== undefined ? form.controls['student'] : null;
            if (studentInput !== null) {
                studentInput.reset();
            }
        }
    }

    private getLessonsQuery(): string {
        // We only allow to create reservations for not executed/not cancelled lessons
        // for lessons on this week
        let fromDate = new Date();
        let toDate = new Date();
        toDate.setDate(fromDate.getDate() + ReservationDialogComponent.MAX_DAYS_TO_SHOW);
        let datePipe = new DatePipe('UTC');
        return 'begining:[' + datePipe.transform(fromDate, 'yyyy-MM-dd') +
            ' TO ' + datePipe.transform(toDate, 'yyyy-MM-dd') + ']';
    }

    private onSaveSuccess(result: Reservation,  action: String) {
        this.eventManager.broadcast({ name: 'reservationListModification', content: {
            action: action,
            content: result
        } });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackLessonById(index: number, item: Lesson) {
        return item.id;
    }

    trackReservationCancellationReasonById(index: number, item: ReservationCancellationReason) {
        return item.id;
    }

    lessonsSort() {
        return ['begining', 'desc'];
    }
}

@Component({
    selector: 'jhi-reservation-popup',
    template: ''
})
export class ReservationPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationPopupService: ReservationPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.reservationPopupService
                    .open(ReservationDialogComponent as Component, params['id']);
            } else if (params['studentId']) {
                this.modalRef = this.reservationPopupService
                    .open(ReservationDialogComponent as Component, undefined, params['studentId']);
            } else if (params['lessonId']) {
                this.modalRef = this.reservationPopupService
                    .open(ReservationDialogComponent as Component, undefined, undefined, params['lessonId']);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation-dialog.component.ts